import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { hrSubUrl } from '../catalog';
import Icon from '../Icon';

// sub-modules of a group shown together as a tab bar (group.tabs), in that order — styled as the
// button tabs of Payment Voucher and Enterprise Requisition: equal-width buttons, the active one filled navy
export function GroupTabs({ group, active }) {
  const tabs = (group.tabs || []).map(k => group.submodules.find(s => s.key === k)).filter(Boolean);
  if (tabs.length < 2) return null;
  return (
    // every tab on one line, equal widths; long labels wrap inside their button instead of adding a row
    <div role="tablist" style={{ display: 'grid', gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))`, gap: tabs.length > 8 ? 8 : 12, marginBottom: 20 }}>
      {tabs.map(s => (
        <NavLink key={s.key} to={hrSubUrl(s.key)} role="tab"
                 style={({ isActive: onUrl }) => { const isActive = active ? s.key === active : onUrl; return {
                   minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                   padding: tabs.length > 8 ? '10px 6px' : '12px 8px', borderRadius: 12, textAlign: 'center', textDecoration: 'none',
                   background: isActive ? '#0b318bff' : 'var(--bg-card, #fff)',
                   color: isActive ? '#ffffff' : 'var(--text-primary, #0d1b24)',
                   border: '1px solid black', fontWeight: 600, fontSize: tabs.length > 8 ? 12 : 13, lineHeight: 1.25, whiteSpace: 'normal',
                   boxShadow: isActive ? '0 4px 12px rgba(11,49,139,0.2)' : 'var(--shadow-sm)',
                   transition: 'all 0.2s ease',
                 }; }}>
          {s.title}
        </NavLink>
      ))}
    </div>
  );
}

// a tab's own tabs (Stephanet's cc-subtabs), e.g. Attendance Management: Attendance · Attendance Report · Attendance Edit Log
export function SubTabs({ items, active }) {
  if (items.length < 2) return null;
  return (
    <div className="cc-subtabs no-print" role="tablist">
      {items.map(t => (
        <Link key={t.key} role="tab" to={hrSubUrl(t.key)} className={t.key === active ? 'active' : ''} aria-current={t.key === active ? 'page' : undefined}>
          <Icon name={t.parent ? t.icon : t.subtabIcon || 'layout-dashboard'} size={15} /> {t.subtitle || t.title}
        </Link>
      ))}
    </div>
  );
}
